import { combineReducers } from "redux";
import { smscReducer } from "./smscReducers";

const reducers = combineReducers({
    allSMSC:smscReducer,
})

export default reducers;